import { createStore } from "jotai";
import type { AccessSpecifier } from "shared/types";
import { setChatSendMode } from "shared/features/chat/store";

/**
 * Create an isolated Jotai store for a single pinned chat instance.
 *
 * Wrapping a PinnedChatPanel in `<Provider store={store}>` ensures every
 * atom read/write inside that subtree is scoped to this store, preventing
 * cross-contamination between multiple pinned chats and the main Chat.
 */
export function createPinnedChatStore(
  defaultMode: AccessSpecifier = "private",
) {
  const store = createStore();
  store.set(setChatSendMode, defaultMode);
  return store;
}
